var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.624,
    height: 6.032,
    viewBox: "0 0 21.624 6.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M505,327h6.635v6.032H505Z",
    transform: "translate(-505 -327)",
    fill: "#ff7200"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vendor_code",
    "data-name": "vendor code",
    transform: "translate(-146.737 -327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(161.726 327)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M511.373,330.241h-1.528l.764-1.337a.642.642,0,0,0-1.108-.65l-.764,1.337-.764-1.337a.642.642,0,0,0-1.108.65l.764,1.337H506.1a.678.678,0,0,0-.688.649.669.669,0,0,0,.649.649h1.528l-.764,1.337a.642.642,0,1,0,1.108.65l.764-1.337.764,1.337a.642.642,0,0,0,1.108-.65l-.764-1.337h1.528a.669.669,0,0,0,.65-.649.591.591,0,0,0-.611-.649Z",
    transform: "translate(-505.387 -327.874)",
    fill: "#ff7200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M389.676,330.245h-1.528l.764-1.337a.635.635,0,0,0-.229-.879.67.67,0,0,0-.879.229l-.764,1.337-.764-1.337a.642.642,0,0,0-1.108.65l.764,1.337H384.4a.649.649,0,1,0,0,1.3h1.528l-.764,1.337a.642.642,0,0,0,1.108.65l.764-1.337.764,1.337a.642.642,0,0,0,1.108-.65l-.764-1.337h1.528a.669.669,0,0,0,.649-.649A.644.644,0,0,0,389.676,330.245Z",
    transform: "translate(-229.491 -0.878)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M267.446,330.243h-1.528l.764-1.337a.642.642,0,0,0-1.108-.65l-.764,1.337-.764-1.337a.729.729,0,0,0-.917-.229.635.635,0,0,0-.229.879l.764,1.337h-1.528a.649.649,0,1,0,0,1.3h1.528l-.764,1.337a.642.642,0,0,0,1.108.65l.764-1.337.764,1.337a.642.642,0,0,0,1.108-.65l-.764-1.337h1.528a.669.669,0,0,0,.65-.649.613.613,0,0,0-.611-.649Z",
    transform: "translate(-114.749 -0.876)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.d60f1c79e6bbb72ded3c3b6c5dcf7cee.svg";
export { ForwardRef as ReactComponent };